import { useEffect, useRef } from 'react';

/**
 * Runs the callback when the page is restored from the back/forward cache
 * (browser Back after a full-page redirect). The frozen React state comes back
 * verbatim, so screens that hold a `redirecting` busy flag across
 * `redirectToUrl` must reset it here or they stay stuck on the loader.
 */
export function useBfcacheRestore(onRestore: () => void) {
  const cb = useRef(onRestore);
  cb.current = onRestore;

  useEffect(() => {
    const handler = (e: PageTransitionEvent) => {
      if (e.persisted) cb.current();
    };
    window.addEventListener('pageshow', handler);
    return () => window.removeEventListener('pageshow', handler);
  }, []);
}
